import {initializeApp} from 'firebase/app';
import {getAuth, signInWithRedirect, signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword,signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, collection, writeBatch,query , getDocs } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyAnttSD3Rh3kdePsuT65njdE3nfyvp_fuM",
    authDomain: "shopping-app-dp.firebaseapp.com",
    projectId: "shopping-app-dp",
    storageBucket: "shopping-app-dp.appspot.com",
    messagingSenderId: "661719040959",
    appId: "1:661719040959:web:208786c4d6ea505c3d170a"
  };
  const firebaseapp = initializeApp(firebaseConfig);
  const googleprovider= new GoogleAuthProvider();
  googleprovider.setCustomParameters({
    prompt:"select_account"
  })

  export const auth= getAuth();
  export const signInWithGoogleopopup=()=> signInWithPopup(auth,googleprovider)
  export const signInWithGoogleRedirect=()=>signInWithRedirect(auth,googleprovider);
  

  export const db =getFirestore();

  export const addCollectionAndDocuments= async (collectionKey,objectsToAdd, field)=>{
    const collectionRef = collection(db, collectionKey )
    const batch = writeBatch(db);
    objectsToAdd.forEach((object)=>{
      const docRef=doc(collectionRef, object.title.toLowerCase())
      batch.set(docRef, object)

    })
    await batch.commit()

  }
  

  export const getCateogiresAndDocuments=async()=>{
    const collectionRef=collection(db, 'categories')
    const q = query(collectionRef)

    const querySnapshot =await getDocs(q);
    return querySnapshot.docs.map(docSnapshot=>docSnapshot.data())
    
    // .reduce((acc, docSnapshot)=>{
    //   const {title,items}=docSnapshot.data();
    //   acc[title.toLowerCase()]=items;
    //   return acc;
    // },{})
    // return categoryMap;
  }


  export const createUserDocumentFromAuth = async(userAuth, additionalInformation={})=>{
    if(!userAuth) return;

    const userDocRef=doc(db,'users', userAuth.uid)


   

    const userSnapshot=await getDoc(userDocRef);
   

    if(!userSnapshot.exists()){
        const {displayName,email}=userAuth;
        const createdAt=new Date();

        try{
            await setDoc(userDocRef, {
                displayName,
                email,
                createdAt,
                ...additionalInformation
            })
        }
        catch(error){
            
            console.log('error creating user', error.message);
            

        }
    }
    return userSnapshot;


  }
  export const createAuthUserWithEmailAndPassword=async (email,password)=>{
    if(!email || !password) return ;
    return await createUserWithEmailAndPassword(auth, email, password)

  }

  export const signInAuthUserWithEmailAndPassword=async (email,password)=>{
    if(!email || !password) return ;
    return await signInWithEmailAndPassword(auth, email, password)

  } 

  export const signOutUser =async()=> await signOut(auth)

  export const onAuthStateChangedListner =(callback)=> onAuthStateChanged(auth, callback)

  export const getCurrentUser=()=>{
    return new Promise((resolve, reject)=>{
      const unsubscribe=onAuthStateChanged(
        auth,
        (userAuth)=>{
          unsubscribe();
          resolve(userAuth)
        },
        reject
      )
    })
  }